export const TIME_TILE_MOBILE_CONFIG = {
	height: 74,
}